import {Component, input} from '@angular/core';
import {Tone} from '../ui-colors';

/** 8px dot + 13px label in the tone color, with an optional line for the problem in the same tone. */
@Component({
    selector: 'app-status-dot',
    templateUrl: './status-dot.component.html',
    styleUrl: './status-dot.component.scss',
    host: {
        '[class]': '"tone-" + tone()'
    }
})
export class StatusDotComponent {
    readonly tone = input<Tone>('neutral');
    readonly problem = input<string | null>(null);
}
